module.exports = __webpack_public_path__ + "static/img/product_society_information.9e261db.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_information.png
// module id = irLS
// module chunks = 0